"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderRadius = void 0;
/**
 * @deprecated please use border from @smartsheet/design-tokens.
 */
const borderRadius = () => 4;
exports.borderRadius = borderRadius;
//# sourceMappingURL=borders.js.map